var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99083 16.4746C9.72167 16.5696 9.27833 16.5696 9.00917 16.4746C6.71333 15.6908 1.58333 12.4212 1.58333 6.87958C1.58333 4.43333 3.55458 2.45416 5.985 2.45416C7.42583 2.45416 8.70042 3.15083 9.5 4.2275C10.2996 3.15083 11.5821 2.45416 13.015 2.45416C15.4454 2.45416 17.4167 4.43333 17.4167 6.87958C17.4167 12.4212 12.2867 15.6908 9.99083 16.4746Z",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.502c924178e88e729b538b860a4f08e8.svg";
export { ForwardRef as ReactComponent };